"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Binding_1 = require("./Binding");
var Binding_2 = require("./Binding");
exports.Binding = Binding_2.Binding;
class CopyOnWriteSet extends Set {
    add(value) { super.add.call(Binding_1.W(this), value); return this; }
    clear() { return super.clear.call(Binding_1.W(this)); }
    delete(value) { return super.delete.call(Binding_1.W(this), value); }
    forEach(callbackfn, thisArg) { super.forEach.call(Binding_1.R(this), callbackfn, thisArg); }
    has(value) { return super.has.call(Binding_1.R(this), value); }
    get size() { return super.size; }
    entries() { return super.entries.call(Binding_1.R(this)); }
    keys() { return super.keys.call(Binding_1.R(this)); }
    values() { return super.values.call(Binding_1.R(this)); }
    static seal(owner, prop, set) {
        return Binding_1.Binding.seal(owner, prop, set, CopyOnWriteSet.prototype, CopyOnWriteSet.clone);
    }
    static clone(set) {
        return new Set(Set.prototype.values.call(set));
    }
}
exports.CopyOnWriteSet = CopyOnWriteSet;
